module.exports = "/images/vendor/vue-paycard/src/hipercard.png?b23f0f9594c0b340ecee508945668e34";